import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the type for a single access right item
interface AccessRight {
  id?: string | number;
  name?: string;
  code?: string;
  description?: string;
  [key: string]: any; // Allow for additional properties
}

// Define initial state type
const initialState: AccessRight[] = [];

// Create a slice for access rights
const accessRightsSlice = createSlice({
  name: "accessRights",
  initialState,
  reducers: {
    // Action to set access rights
    setAccessRights: (state: AccessRight[], action: PayloadAction<AccessRight[]>) => {
      console.log("Access payload received:", action.payload);
      return action.payload;
    },
    // Action to clear access rights
    clearAccessRights: () => {
      return [];
    },
  },
});

// Export actions for use in components
export const { setAccessRights, clearAccessRights } = accessRightsSlice.actions;

// Export reducer to be included in the store
export default accessRightsSlice.reducer;